const VerificationAlert = () => {
    const verifikasi = `${window.location.origin}/auth/email/verify?continue=${window.location.href}`;
    return (
        <div className="verification-notif">
            Harap lakukan <a href={verifikasi}>verifikasi email</a> terlebih dahulu
        </div>
    );
}

export default VerificationAlert;